import { Column, Row } from '../experimental.grid';

import {
    CellContext,
    ColumnContext,
    RowContext,
} from './kpi-set.observation.model';

export interface KpiSetState {
    pending: {
        reload?: boolean;
    };

    gridColumns?: Array<Column<ColumnContext>>; // this is special. it should not be recreated else the entire grid would be invalidated
    gridRows?: Array<Row<RowContext, CellContext>>;

    activeGoalRows?: Array<Row<RowContext, CellContext>>;
    focusMetricRows?: Array<Row<RowContext, CellContext>>;
}

export const defaultState = (): KpiSetState => ({
    pending: {},
});
